import api from '@/services/api'

/**
 * 获取配送员列表
 */
export function getDrivers(params) {
  return api.get('/delivery/drivers', { params })
}

/**
 * 获取所有配送员
 */
export function getAllDrivers(params) {
  return api.get('/delivery/drivers/all', { params })
}

/**
 * 获取配送员详情
 */
export function getDriver(id) {
  return api.get(`/delivery/drivers/${id}`)
}

/**
 * 创建配送员
 */
export function createDriver(data) {
  return api.post('/delivery/drivers', data)
}

/**
 * 更新配送员
 */
export function updateDriver(id, data) {
  return api.put(`/delivery/drivers/${id}`, data)
}

/**
 * 删除配送员
 */
export function deleteDriver(id) {
  return api.delete(`/delivery/drivers/${id}`)
}

/**
 * 更新配送员状态
 */
export function updateDriverStatus(id, data) {
  return api.patch(`/delivery/drivers/${id}/status`, null, { params: data })
}

/**
 * 切换接众包单开关
 */
export function toggleAcceptContractorOrders(id, accept) {
  return api.patch(`/delivery/drivers/${id}/accept-contractor-orders`, null, { 
    params: { accept } 
  })
}

/**
 * 获取空闲配送员
 */
export function getIdleDrivers(params) {
  return api.get('/delivery/drivers/idle', { params })
}

/**
 * 获取配送员统计数据
 */
export function getDriverStats(params) {
  return api.get('/delivery/drivers/stats', { params })
}

/**
 * 检查手机号是否已存在
 */
export function checkDriverPhone(phone) {
  return api.get('/delivery/drivers/check-phone', { params: { phone } })
}

/**
 * ==================== 配送任务 API ====================
 */

/**
 * 指派任务给自己的配送员
 */
export function assignTask(data) {
  return api.post('/delivery/tasks/assign', data)
}

/**
 * 发布众包任务
 */
export function publishContractorTask(data) {
  return api.post('/delivery/tasks/contractor', data)
}

/**
 * 抢单
 */
export function grabTask(taskId, driverId) {
  return api.post(`/delivery/tasks/${taskId}/grab`, { driverId })
}

/**
 * 更新任务状态
 */
export function updateTaskStatus(taskId, status) {
  return api.patch(`/delivery/tasks/${taskId}/status`, { status })
}

/**
 * 取消任务
 */
export function cancelTask(taskId, reason) {
  return api.post(`/delivery/tasks/${taskId}/cancel`, null, { params: { reason } })
}

/**
 * 获取任务列表（批发商视角）
 */
export function getTasksByWholesaler(params) {
  return api.get('/delivery/tasks/wholesaler', { params })
}

/**
 * 获取任务列表（配送员视角）
 */
export function getTasksByDriver(params) {
  return api.get('/delivery/tasks/driver', { params })
}

/**
 * 获取可抢的众包任务
 */
export function getAvailableContractorTasks(params) {
  return api.get('/delivery/tasks/contractor/available', { params })
}

/**
 * 获取任务详情
 */
export function getTaskById(taskId) {
  return api.get(`/delivery/tasks/${taskId}`)
}

/**
 * 现场收款 COD
 */
export function collectCOD(taskId, params) {
  return api.post(`/delivery/tasks/${taskId}/collect-cod`, null, { params })
}
